import React from "react";
import { currency } from "../../pages/admin/reports/filterUtils";
interface TopItem {
  name: string;
  orders: number;
  revenue: number;
}

interface TopItemsTableProps {
  items: TopItem[];
}

const TopItemsTable: React.FC<TopItemsTableProps> = ({ items }) => {
  return (
    <div className="overflow-x-auto rounded-xl border border-gray-200 bg-white">
      <div className="max-h-[430px] overflow-y-auto">
      <table className="min-w-full border-collapse">
        <thead className="bg-gray-50 text-xs text-gray-700 sm:text-sm">
          <tr className="border-b border-gray-200">
            <th className="p-3 text-left font-semibold">Item Name</th>
            <th className="p-3 text-center font-semibold">Orders</th>
            <th className="p-3 text-center font-semibold">Revenue</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item) => (
            <tr
              key={item.name}
              className="border-b border-gray-200 hover:bg-gray-50"
            >
              <td className="p-3 text-sm text-gray-700">{item.name}</td>
              <td className="p-3 text-center text-sm text-gray-700">
                {item.orders}
              </td>
              <td className="p-3 text-center text-sm text-gray-700">
                {currency(item.revenue)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      </div>
    </div>
  );
};

export default TopItemsTable;
